import { Ellipsis } from 'lucide-react';
import { Link, useLocation } from 'react-router';
import { cx } from '../lib/cx.ts';
import { MOBILE_SECTION_KEYS } from './nav.ts';
import { sectionMatches, useNavSections } from './useNavSections.ts';

/** Phone tab bar (<768px): four sections plus "เพิ่มเติม" for the full menu. */
export function BottomNav({ moreExpanded, onOpenMore }: { moreExpanded: boolean; onOpenMore: () => void }) {
  const sections = useNavSections();
  const { pathname } = useLocation();
  const tabs = MOBILE_SECTION_KEYS.map((key) => sections.find((s) => s.key === key)).filter((s) => s !== undefined);
  return (
    <nav className="bottom-nav" aria-label="เมนูลัด">
      <ul>
        {tabs.map((section) => {
          const Icon = section.icon;
          const active = sectionMatches(section, pathname);
          return (
            <li key={section.key}>
              <Link to={section.items[0]!.to} className={cx('bottom-nav__item', active && 'is-active')} aria-current={active ? 'page' : undefined}>
                <Icon size={22} strokeWidth={1.75} aria-hidden="true" />
                <span>{section.shortLabel}</span>
              </Link>
            </li>
          );
        })}
        <li>
          <button type="button" className="bottom-nav__item" aria-expanded={moreExpanded} aria-controls="nav-drawer" onClick={onOpenMore}>
            <Ellipsis size={22} strokeWidth={1.75} aria-hidden="true" />
            <span>เพิ่มเติม</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
